
import Section from '../components/Section'
import ImageCarousel from "../components/ImageCarousel";


const slides = [
  { src: "/LandingLogo2.png", alt: "NFT-Hub Landing" },
  { src: "/AdminNft.png", alt: "User" },
  { src: "/AdminUsers.png", alt: "NFTs" },
  { src: "/AdminOrders.png", alt: "Order" },
  // beliebig erweitern …
];


export default function NFTHub() {
  return (
    <Section title="NFT‑Hub" subtitle="Unser aktuelles Fokus‑Projekt – modern, modular, nachvollziehbar.">
      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl glass p-6">
          <h3 className="font-semibold">Features</h3>
          <ul className="mt-3 list-disc pl-5 text-slate-300 space-y-1">
            <li>Buyer/Creator‑Rollen, Creator‑Abo via Stripe (Sandbox)</li>
            <li>NFT‑Upload (Cloudinary), Duplikat‑Check via Hash</li>
            <li>Zahlungen & Webhooks, Besitzzuordnung</li>
            <li>PDF‑Zertifikat per Mail (Puppeteer)</li>
            <li>Admin‑Datenansicht (aus Sicherheitsgründen nur als Screenshot)</li>
          </ul>
          <div className="mt-auto pt-4 flex justify-center">
    <a
      href="https://nft-hub.m2websolutions.eu"
      target="_blank"
      rel="noreferrer noopener"
      className="group inline-flex items-center justify-center gap-2 rounded-xl bg-black px-4 py-2 font-semibold text-white shadow-sm
                 transition-colors duration-200 hover:bg-zinc-700 active:bg-zinc-600
                 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
    >
      NFT-Hub öffnen
      <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"
           className="opacity-80 transition-transform duration-200 group-hover:translate-x-0.5">
        <path d="M5 12h12m-4-4l4 4-4 4" fill="none" stroke="currentColor"
              strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </a>
  </div>
  </div>
        <ImageCarousel
          images={slides}
          intervalMs={4500}
          className="h-[280px] md:h-[320px]"
          rounded="rounded-2xl"
        />


      </div>
    </Section>
  )
}
